import heroDesktop from '@/assets/funnel28/hero-desktop.webp';
import heroMobile from '@/assets/funnel28/hero-mobile.webp';
import avatarGroupIcons from '@/assets/funnel28/icons.webp';
import CheckmarkIcon from '../../icons/CheckmarkIcon';
import GoToQuizButton from './GoToQuizButton';
import GoToCheckoutButton from './GoToCheckoutButton';

const checklistItems = [
  'Access thousands of mom-friendly jobs and employers',
  "Get matched to best-fit jobs you're most likely to land",
  'Auto-apply to numerous jobs with resumes tailored to each role',
  'Ace any interview with live AI coach',
];

const HeroSection = ({ showCheckoutButton = true, funnelId = null }) => {
  return (
    <>
      {/* ============ MOBILE LAYOUT ============ */}
      <div
        className="mom-hero-anim w-full h-[300px] overflow-hidden md:mt-6 block md:hidden"
        style={{
          backgroundImage: `url(${heroMobile})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          animation: 'scrollHorizontal 250s linear infinite',
        }}
      />
      <div className="bg-white flex-1 flex flex-col md:hidden">
        <div className="px-4 pt-6 pb-4 md:pb-2 flex flex-col gap-6">
          <div className="flex items-center gap-2">
            <img src={avatarGroupIcons} alt="User avatars" className="h-[34px]" />
            <div className="flex flex-col">
              <span className="text-[12px] font-semibold leading-[1em]">10,500+</span>
              <span className="text-[12px] font-normal text-[#535353] leading-[1em]">
                moms landed new jobs last month
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <h1 className="text-[32px] font-semibold leading-[1.25em] tracking-[-0.1px]">
              Land a flexible job <br />
              <span className="text-[#E43C5F]">3x faster.</span> Hassle-free.
            </h1>
            <p className="text-[14px] font-normal leading-[1.43em]">
              Don’t wait—get your dream job 3x faster with zero stress:
            </p>
            <GoToQuizButton className="w-full" funnelId={funnelId} />
            {showCheckoutButton && (
              <div className="flex flex-col gap-3">
                <GoToCheckoutButton className="w-full" />
              </div>
            )}
            <div className="flex flex-col gap-3">
              {checklistItems.map((item, i) => (
                <div key={i} className="flex items-start gap-[10px]">
                  <span className="flex-shrink-0 mt-[1px]">
                    <CheckmarkIcon />
                  </span>
                  <p className="text-[16px] font-normal leading-[1.43em] tracking-[-0.01em]">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ============ DESKTOP LAYOUT ============ */}
      <div className="hidden md:block">
        <section className="max-w-[1300px] mx-auto px-6 lg:px-8 pt-8 pb-16">
          <div className="flex items-center justify-between gap-12">
            <div className="max-w-[50%] flex flex-col">
              <div className="flex items-center gap-2">
                <img src={avatarGroupIcons} alt="User avatars" className="h-[34px]" />
                <div className="flex flex-col">
                  <span className="text-[12px] font-semibold leading-[1em]">10,500+</span>
                  <span className="text-[12px] font-normal text-[#535353] leading-[1em]">
                    moms landed new jobs last month
                  </span>
                </div>
              </div>
              <h1 className="text-[56px] font-bold tracking-tight leading-[1.15em]">
                Land a flexible job <span className="text-[#E43C5F]">3x faster.</span> Hassle-free.
              </h1>

              <div className="flex flex-col gap-4 pt-6">
                {checklistItems.map((item, i) => (
                  <div key={i} className="flex items-start gap-[10px]">
                    <span className="flex-shrink-0 mt-[1px]">
                      <CheckmarkIcon />
                    </span>
                    <p className="text-[18px] font-normal leading-[1.33em] tracking-[-0.1px]">{item}</p>
                  </div>
                ))}
              </div>
              <div className="pt-10">
                <p className="font-normal pb-2">Don’t wait—get your dream job 3x faster with zero stress:</p>
                <div className="flex gap-4">
                  <GoToQuizButton funnelId={funnelId ?? 28} />
                  {showCheckoutButton && <GoToCheckoutButton />}
                </div>
              </div>
            </div>
            <div
              className="mom-hero-anim w-[49%] h-[600px] rounded-3xl"
              style={{
                backgroundImage: `url(${heroDesktop})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                animation: 'scrollVertical 150s linear infinite',
              }}
            />
          </div>
        </section>
      </div>

      <style>{`
        @media (prefers-reduced-motion: reduce) {
          .mom-hero-anim {
            animation: none !important;
          }
        }

        @keyframes scrollHorizontal {
          0% { background-position: -1000% center; }
          100% { background-position: 0% center; }
        }
        @keyframes scrollVertical {
          0% { background-position: center 0%; }
          100% { background-position: center -1000%; }
        }
      `}</style>
    </>
  );
};

export default HeroSection;
